/**
 * GA4 analytics tracking helpers for the TWW expansion recap.
 *
 * Each function wraps a single RIO_TRACK_EVENT call so component code
 * stays clean and event names / parameters stay consistent.
 */

// -- Funnel events ----------------------------------------------------------

export function trackRecapGenerateStart(recapType: string) {
  RIO_TRACK_EVENT('event', 'recap_generate_start', { recap_type: recapType });
}

export function trackRecapGenerateComplete(recapType: string) {
  RIO_TRACK_EVENT('event', 'recap_generate_complete', { recap_type: recapType });
}

export function trackRecapGenerateFail(recapType: string, errorType: string) {
  RIO_TRACK_EVENT('event', 'recap_generate_fail', { recap_type: recapType, error_type: errorType });
}

export function trackRecapView(recapType: string, slideCount: number) {
  RIO_TRACK_EVENT('event', 'recap_view', { recap_type: recapType, slide_count: slideCount });
}

export function trackRecapComplete(recapType: string, slideCount: number) {
  RIO_TRACK_EVENT('event', 'recap_complete', { recap_type: recapType, slide_count: slideCount });
}

// -- Slide engagement -------------------------------------------------------

export function trackSlideView(recapType: string, slideName: string, slideIndex: number) {
  RIO_TRACK_EVENT('event', 'recap_slide_view', {
    recap_type: recapType,
    slide_name: slideName,
    slide_index: slideIndex
  });
}

export function trackSlideExit(recapType: string, slideName: string, slideIndex: number, dwellSec: number) {
  RIO_TRACK_EVENT('event', 'recap_slide_exit', {
    recap_type: recapType,
    slide_name: slideName,
    slide_index: slideIndex,
    dwell_sec: dwellSec
  });
}

export function trackRecapProgress(recapType: string, percent: number) {
  RIO_TRACK_EVENT('event', 'recap_progress', { recap_type: recapType, percent });
}

// -- Share events (GA4 recommended `share` event) ---------------------------

export function trackShare(recapType: string, method: string, contentType: string, itemId: string) {
  RIO_TRACK_EVENT('event', 'share', { method, content_type: contentType, item_id: itemId, recap_type: recapType });
}

// -- Quiz events ------------------------------------------------------------

export function trackQuizAnswer(recapType: string, quizId: string, isCorrect: boolean, wasForced: boolean) {
  RIO_TRACK_EVENT('event', 'recap_quiz_answer', {
    recap_type: recapType,
    quiz_id: quizId,
    is_correct: isCorrect,
    was_forced: wasForced
  });
}

export function trackQuizComplete(recapType: string, correctCount: number, totalCount: number) {
  RIO_TRACK_EVENT('event', 'recap_quiz_complete', {
    recap_type: recapType,
    correct_count: correctCount,
    total_count: totalCount
  });
}

// -- Auto-play events -------------------------------------------------------

export function trackAutoPlay(recapType: string, action: string, slideName: string, slideIndex: number) {
  RIO_TRACK_EVENT('event', 'recap_autoplay', {
    recap_type: recapType,
    action,
    slide_name: slideName,
    slide_index: slideIndex
  });
}
